// src/app/features/maestros/services/fee.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FeeType } from 'src/app/shared/models/fee';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FeeService {
  private feeUrl = environment.financeApiBaseUrl + '/api/fee';
  private feeTypeUrl = environment.financeApiBaseUrl + '/api/feeType';

  constructor(private http: HttpClient) {}

  getFee(params: any): Observable<any> {
    return this.http.get(this.feeUrl, { params });
  }

  createFee(data: any): Observable<any> {
    return this.http.post(this.feeUrl, data);
  }

  updateFee(data: any): Observable<any> {
    return this.http.put(this.feeUrl, data);
  }

  deleteFee(ids: number[]): Observable<any> {
    return this.http.delete(this.feeUrl, { params: { ids } });
  }

  getFeeType(params: any): Observable<any> {
    return this.http.get(this.feeTypeUrl, { params });
  }

  createFeeType(data: any): Observable<any> {
    return this.http.post(this.feeTypeUrl, data);
  }

  updateFeeType(data: any): Observable<any> {
    return this.http.put(this.feeTypeUrl, data);
  }

  deleteFeeType(ids: number[]): Observable<any> {
    return this.http.delete(this.feeTypeUrl, { params: { ids } });
  }
}
